module.exports = __webpack_public_path__ + "static/media/connectstripe.dd3cedd3.png";